import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Box,
  Button,
  Chip,
  Divider,
  IconButton,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { dateFormatter } from '../../../utils/dateFormatter';
import { changeStatusName } from '../../../utils/changeStatusName';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import Delete from '@mui/icons-material/Delete';

const actionPZ04 = {
  ZABLOKOWANE: 'ZABLOKOWANE',
  DO_ZABLOKOWANIA: 'DO_ZABLOKOWANIA',
  DO_UWOLNIENIA: 'DO_UWOLNIENIA',
  UWOLNIONE: 'UWOLNIONE',
  DO_ZNISZCZENIA: 'DO_ZNISZCZENIA',
  ZNISZCZONE: 'ZNISZCZONE',
};

const decisions = [
  {
    description: 'Do zablokowania',
    value: actionPZ04.DO_ZABLOKOWANIA,
    decisionMaker: ['KONTROLER', 'STARSZY_MAGAZYNIER', 'ADMIN'],
    responses: [
      {
        description: 'Zablokowane',
        value: actionPZ04.ZABLOKOWANE,
      },
    ],
  },
  {
    description: 'Do uwolnienia',
    value: actionPZ04.DO_UWOLNIENIA,
    decisionMaker: ['KONTROLER', 'STARSZY_MAGAZYNIER', 'ADMIN'],
    responses: [
      {
        description: 'Uwolnione',
        value: actionPZ04.UWOLNIONE,
      },
    ],
  },
  {
    description: 'Do zniszczenia',
    value: actionPZ04.DO_ZNISZCZENIA,
    decisionMaker: ['KONTROLER', 'STARSZY_MAGAZYNIER'],
    responses: [
      {
        description: 'Zniszczone',
        value: actionPZ04.ZNISZCZONE,
      },
    ],
  },
  {
    description: 'Zablokowane',
    value: actionPZ04.ZABLOKOWANE,
    decisionMaker: ['LABO', 'SUPER_LABO', 'ADMIN'],
    responses: [
      {
        description: 'Do uwolnienia',
        value: actionPZ04.DO_UWOLNIENIA,
      },
    ],
  },
  {
    description: 'Uwolnione',
    value: actionPZ04.UWOLNIONE,
    decisionMaker: ['LABO', 'SUPER_LABO', 'ADMIN'],
    responses: [
      {
        description: 'Do uwolnienia',
        value: actionPZ04.DO_UWOLNIENIA,
      },
    ],
  },
];

// const responses = [
//   {
//     description: 'Zablokowane',
//     value: actionPZ04.ZABLOKOWANE,
//     decisionMaker: ['LABO', 'SUPER_LABO'],
//     decisions: [
//       {
//         description: 'Do uwolnienia',
//         value: actionPZ04.DO_UWOLNIENIA,
//       },
//     ],
//   },
//   {
//     description: 'Uwolnione',
//     value: actionPZ04.UWOLNIONE,
//   },
// ];

const DecisionFormPZ04 = ({ material, action, props }) => {
  const user = useSelector((state) => getUser(state));

  const [currentDecision, setCurrentDecision] = useState('');
  const [decisionResponse, setDecisionResponse] = useState('');
  const [comments, setComments] = useState('');
  const [pal, setPal] = useState('');
  const [cas, setCas] = useState('');
  const [alert, setAlert] = useState(false);
  const [alert2, setAlert2] = useState(false);
  const [alert3, setAlert3] = useState(false);

  const handleClose = () => {
    setAlert(false);
    setAlert2(false);
    setAlert3(false);
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const decision = decisions.find((el) => el.value === props.activeDecision);
    setCurrentDecision(decision);
    setDecisionResponse(decision.decisionMaker.includes(user.users.role));
  }, [props.activeDecision]);

  const handleHL = (qty, casHL) => {
    return (parseFloat(qty) * parseFloat(casHL)).toFixed(2);
  };
  const handleStatusByRestQty = (props) => {
    let actualQty = parseFloat(props.qty);

    props.actionDetails.map((elA) => {
      if (elA.status === actionPZ04.UWOLNIONE) {
        actualQty -= parseFloat(elA.qty);
      }
      if (elA.status === actionPZ04.ZNISZCZONE) {
        actualQty -= parseFloat(elA.qty);
      }
    });

    if (actualQty === 0) {
      return 'DONE';
    }
    if (actualQty !== parseFloat(props.qty) && actualQty > 0) {
      return 'IN_PROGRESS';
    }
    if (actualQty === parseFloat(props.qty)) {
      return 'NEW';
    }
  };
  const { t } = useTranslation();
  const [currentStatus, setCurrentStatus] = useState(
    handleStatusByRestQty(props),
  );

  const handleSubmit = (value) => {
    let actualQty = parseFloat(props.qty);

    props.actionDetails.map((elA) => {
      if (elA.status === actionPZ04.UWOLNIONE) {
        actualQty -= parseFloat(elA.qty);
      }
      if (elA.status === actionPZ04.ZNISZCZONE) {
        actualQty -= parseFloat(elA.qty);
      }
    });

    const cas2 = cas !== '' ? parseInt(cas) : 0;
    const pal2 = pal !== '' ? parseInt(pal) : 0;

    if (isNaN(cas2) || isNaN(pal2)) {
      setAlert(true);
      return;
    }
    if (
      (value === actionPZ04.UWOLNIONE || value === actionPZ04.ZNISZCZONE) &&
      cas2 === 0 &&
      pal2 === 0
    ) {
      setAlert2(true);
      return;
    }
    const totalCas = pal2 * material.palletQty + cas2;

    if (totalCas > actualQty) {
      setAlert3(true);
      return;
    }
    const data = {
      id: props.id,
      reportId: props.reportId,
      userId: user.users.id,
      comments: comments,
      activeDecision: value,
      qty:
        value === actionPZ04.DO_UWOLNIENIA ||
        value === actionPZ04.DO_ZNISZCZENIA
          ? props.qty
          : totalCas.toString(),
    };
    console.log(data);
    action(data);
  };

  const buttonColor = (action) => {
    switch (action) {
      //   case 'FIXED':
      //     return '#FF9900';
      //   case 'BROKEN':
      //     return '#FF0033';
      case 'ZNISZCZONE':
        return '#FF0033';
      //   case 'MOVED':
      //     return '#3399FF';
      case 'UWOLNIONE':
        return '#339900';
      //   case 'REPAIR':
      //     return '#FF9900';
      case 'DO_ZNISZCZENIA':
        return '#FF0033';
      //   case 'MOVEMENT':
      //     return '#3399FF';
      //   case 'SEGREGATION':
      //     return '#FF9900';
      case 'DO_UWOLNIENIA':
        return '#339900';
      //   case 'LINE_SEGREGATION':
      //     return '#FF9900';
      //   case 'GOOD':
      //     return '#339900';
      //   case 'INCORRECT':
      //     return '#FF0033';
      default:
        return 'black';
    }
  };

  const buttonHoverColor = (action) => {
    switch (action) {
      //   case 'FIXED':
      //     return '#CC6600';
      //   case 'BROKEN':
      //     return '#CC0033';
      case 'ZNISZCZONE':
        return '#CC0033';
      //   case 'MOVED':
      //     return '#003399';
      case 'UWOLNIONE':
        return 'green';
      //   case 'REPAIR':
      //     return '#CC6600';
      case 'DO_ZNISZCZENIA':
        return '#CC0033';
      //   case 'MOVEMENT':
      //     return '#003399';
      //   case 'SEGREGATION':
      //     return '#CC6600';
      case 'DO_UWOLNIENIA':
        return 'green';
      //   case 'LINE_SEGREGATION':
      //     return '#CC6600';
      //   case 'GOOD':
      //     return 'green';
      //   case 'INCORRECT':
      //     return '#CC0033';
      default:
        return 'black';
    }
  };

  return (
    <Box component={Paper} sx={{ pb: 1 }}>
      <Snackbar open={alert} autoHideDuration={6000} onClose={handleClose}>
        <Alert variant="filled" severity="error" onClick={handleClose}>
          <AlertTitle>Error</AlertTitle>
          {t('common.isNan')}
        </Alert>
      </Snackbar>
      <Snackbar open={alert2} autoHideDuration={6000} onClose={handleClose}>
        <Alert variant="filled" severity="error" onClick={handleClose}>
          <AlertTitle>Error</AlertTitle>
          {t('common.qtyEmpty')}
        </Alert>
      </Snackbar>
      <Snackbar open={alert3} autoHideDuration={6000} onClose={handleClose}>
        <Alert variant="filled" severity="error" onClick={handleClose}>
          <AlertTitle>Error</AlertTitle>
          {t('common.qtyExceeds')}
        </Alert>
      </Snackbar>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{ mt: 2, ml: 2, fontStyle: 'italic' }}>
          {`${t('pz05.list.index')}: `}
          <span style={{ fontWeight: 'bold' }}>{material.materialNumber}</span>
          {` ${t('pz05.actionDetail.name')}: `}
          <span style={{ fontWeight: 'bold' }}>
            {material.description}
          </span>{' '}
          {` ${t('pz05.actionDetail.qty')}: `}{' '}
          <span style={{ fontWeight: 'bold' }}>{`${props.qty} cas`}</span>{' '}
          {` ${t('pz05.actionDetail.qtyHL')}: `}{' '}
          <span style={{ fontWeight: 'bold' }}>{`${handleHL(
            props.qty,
            material.casHL,
          )}`}</span>
        </Typography>
      </Box>
      <Divider sx={{ width: '100%', mb: 3, bgcolor: '#C09A53' }} />
      <Accordion sx={{ mt: 2 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <TableCell sx={{ width: '15%' }}>
            {t(`pz04.statuses.${props.activeDecision}`)}
          </TableCell>
          <TableCell sx={{ width: '20%' }}>
            {props.actionDetails[0].comments}
          </TableCell>
          <TableCell sx={{ width: '5%' }}>
            {props.actionDetails[0].qty}
          </TableCell>
          <TableCell
            sx={{ width: '25%' }}
          >{`${props.actionDetails[0].user.firstName} ${props.actionDetails[0].user.lastName}`}</TableCell>
          <TableCell sx={{ width: '15%' }}>
            {props.actionDetails[0].user.role}
          </TableCell>
          <TableCell sx={{ width: '10%' }}>
            {dateFormatter(props.updatedAt)}
          </TableCell>
          {currentStatus === 'DONE' && (
            <TableCell sx={{ width: '15%' }}>
              <Chip label={changeStatusName(currentStatus)} color="success" />
            </TableCell>
          )}
          {currentStatus === 'IN_PROGRESS' && (
            <TableCell sx={{ width: '15%' }}>
              <Chip
                label={changeStatusName(currentStatus)}
                sx={{ backgroundColor: 'orange' }}
              />
            </TableCell>
          )}
          {currentStatus === 'NEW' && (
            <TableCell sx={{ width: '15%' }}>
              <Chip label={changeStatusName(currentStatus)} color="primary" />
            </TableCell>
          )}
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer>
            <Table>
              <TableHead>
                <TableCell sx={{ width: '15%' }}>
                  {t('pz05.decision')}
                </TableCell>
                <TableCell sx={{ width: '20%' }}>
                  {t('pz05.decisionComments')}
                </TableCell>
                <TableCell sx={{ width: '5%' }}>{t('beer.qty')}</TableCell>
                <TableCell sx={{ width: '25%' }}>
                  {t('pz05.list.user')}
                </TableCell>
                <TableCell sx={{ width: '15%' }}>
                  {t('pz05.actionDetail.role')}
                </TableCell>
                <TableCell sx={{ width: '10%' }}>
                  {t('pz05.actionDetail.date')}
                </TableCell>
                {user.users.role === 'ADMIN' && (
                  <TableCell sx={{ width: '5%', textAlign: 'center' }}>
                    {t('account.action')}
                  </TableCell>
                )}
              </TableHead>
              <TableBody>
                {props.actionDetails.map((el, index) => (
                  <TableRow key={el.id}>
                    <TableCell sx={{ width: '15%' }}>
                      {t(`pz04.statuses.${el.status}`)}
                    </TableCell>
                    <TableCell sx={{ width: '20%' }}>{el.comments}</TableCell>
                    {el.status === actionPZ04.UWOLNIONE ||
                    el.status === action.ZNISZCZONE ? (
                      <TableCell sx={{ width: '5%' }}>{el.qty}</TableCell>
                    ) : (
                      <TableCell sx={{ width: '5%' }}></TableCell>
                    )}
                    <TableCell sx={{ width: '25%' }}>
                      {`${el.user.firstName} ${el.user.lastName}`}
                    </TableCell>
                    <TableCell sx={{ width: '10%' }}>{el.user.role}</TableCell>
                    <TableCell sx={{ width: '15%' }}>
                      {dateFormatter(el.createdAt)}
                    </TableCell>
                    {user.users.role === 'ADMIN' && index === 0 && (
                      <TableCell sx={{ width: '5%', textAlign: 'center' }}>
                        <IconButton aria-label="delete" color="error">
                          <Delete />
                        </IconButton>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      <Divider sx={{ width: '100%', mt: 3, bgcolor: '#C09A53' }} />
      {decisionResponse && currentStatus !== 'DONE' ? (
        <Box
          sx={{
            display: 'flex',
            mb: 1,
            justifyContent: 'space-around',
            height: '60px',
          }}
        >
          <TextField
            id="comments"
            label={t('pz05.decisionComments')}
            variant="standard"
            sx={{ height: '30px', width: '25%' }}
            value={comments}
            onChange={(e) => setComments(e.target.value)}
          />
          {(props.activeDecision === 'DO_UWOLNIENIA' ||
            props.activeDecision === 'DO_ZNISZCZENIA') && (
            <>
              <TextField
                sx={{ width: '15%', height: '30px', mb: 2 }}
                label={`${t('beer.qtyPAL')} - ${t('beer.fullPallets')}`}
                variant="standard"
                error={isNaN(parseInt(pal)) && pal !== '' ? true : false}
                value={pal}
                helperText={
                  isNaN(parseInt(pal)) && pal !== '' ? t('common.isNan') : ''
                }
                onChange={(e) => setPal(e.target.value)}
              />
              <TextField
                sx={{ width: '20%', height: '30px' }}
                label={`${t('beer.qty')} - ${t('beer.notFull')}`}
                variant="standard"
                error={isNaN(parseInt(cas)) && cas !== '' ? true : false}
                value={cas}
                helperText={
                  isNaN(parseInt(cas)) && cas !== '' ? t('common.isNan') : ''
                }
                onChange={(e) => setCas(e.target.value)}
              />
            </>
          )}
          {currentStatus !== 'DONE' &&
            currentDecision.responses.map((el) => (
              <Button
                key={el.value}
                variant="contained"
                sx={{
                  bgcolor: buttonColor(el.value),
                  ':hover': {
                    bgcolor: buttonHoverColor(el.value),
                  },
                  height: '35px',
                  mt: 2,
                }}
                onClick={() => handleSubmit(el.value)}
              >
                {el.description}
              </Button>
            ))}
        </Box>
      ) : (
        ''
      )}
    </Box>
  );
};
export default DecisionFormPZ04;
